import React from 'react';
import './payments.scss';

import {handleAuthError, useCheckUserAuthentication,fetchLookup} from '../../globals';

import { createStore } from 'devextreme-aspnet-data';
import DataGrid, {
  Column,
  Lookup,
  Editing,
  Selection,
  SearchPanel
} from 'devextreme-react/data-grid';

import { useState, useEffect } from "react";

const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Pagamento'

const remoteDataSource = createStore({
  key: 'id',
  loadUrl: serviceUrl + '/GetAction',
  insertUrl: serviceUrl + '/InsertAction',
  updateUrl:serviceUrl + '/UpdateAction',
  deleteUrl: serviceUrl + '/DeleteAction',

  errorHandler: (error) => {
    handleAuthError(error);
  }
  
});

export default function Payments() {

  const [societa, setSocieta] = useState({});
  const [modalitaPagam, setModalitaPagam] = useState({});
  const [condizioniPagam, setCondizioniPagam] = useState({});

  const user = useCheckUserAuthentication();

  useEffect(() => {
  
    const newServiceUrl1 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
    var newUrl1 =  newServiceUrl1 + "/GetIntermediari";

    const newServiceUrl5 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/ModalitaPagamento';
    var newUrl5 =  newServiceUrl5 + "/GetAction";

    const newServiceUrl6 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/CondizioniPagamento';
    var newUrl6 =  newServiceUrl6 + "/GetAction";

    const fetchData = async () => {

      if (!user?.token) {
        return;
      }

      try {

        const requestOptions = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };

        // const response1 = await fetch(newUrl1,requestOptions);
        // const json1 = await response1.json();
        // console.log(json1);
        // setSocieta(json1);

        const json1 = await fetchLookup(newUrl1,requestOptions);
        if (json1) {
          setSocieta(json1);
        }

        const response5 = await fetch(newUrl5);
        const json5 = await response5.json();
        console.log(json5);
        setModalitaPagam(json5);

        const response6 = await fetch(newUrl6);
        const json6 = await response6.json();
        console.log(json6);
        setCondizioniPagam(json6);
  

      } catch (error) {
        console.log("error", error);
      }
    };
      fetchData();
  }, [user?.token]); // Aggiorna se il token cambia

  return(
  <React.Fragment>
    <h2 className={'content-block'}>Pagamenti</h2>
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
      <DataGrid
          dataSource={remoteDataSource}
          focusedRowEnabled={true}
          >
          <SearchPanel visible={true} width={240} placeholder="Cerca..." />
          <Selection mode="single" />
          <Editing
            mode="row"
            useIcons={true}
            allowAdding={true}
            allowDeleting={true}
            allowUpdating={true}     
          />
          <Column dataField="id" visible={false}/>
          <Column dataField="nome" />
          <Column dataField="anagraficaId" caption="Società" >
            <Lookup dataSource={societa} displayExpr="alias" valueExpr="id" />
          </Column>
          <Column dataField="modalitaPagamentoId"  caption="Modalità Pagamento" visible={true}>
            <Lookup dataSource={modalitaPagam} valueExpr="id" displayExpr="descrizione" />
          </Column>
          <Column dataField="condizioniPagamentoId" caption="Condiz. Pagamento" visible={true}>
            <Lookup dataSource={condizioniPagam} valueExpr="id" displayExpr="descrizione" />
          </Column>
          <Column dataField="bancaDescrizione" />
          <Column dataField="iban" caption={"IBAN"}/>
      
        </DataGrid>  
      </div>
    </div>
  </React.Fragment>
  )
};

